// components/WellbeingMessage.tsx
import * as React from 'react';
import { Typography, Box, makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    padding: 0,
  },
  text: {
    fontWeight: 400,
    color: theme.palette.text.secondary,
    wordWrap: 'break-word',
    whiteSpace: 'normal',
    fontSize: '0.75rem',
    lineHeight: 1.4,
  },
}));

const WellBeingMessage: React.FC = () => {
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      <Typography variant="caption" className={classes.text}>
        Our mission is to improve individual and organisational wellbeing and to
        have a measurable positive impact on the world of work.
      </Typography>
    </Box>
  );
};

export default WellBeingMessage;
